import apiClient from '../clienteFebosAPI';

const RESOURCE = '/herramientas/opciones';

const getCompanyConfig = (
  operacionId,
  {
    company = null
  }
) => {
  let config = { operacionId };
  if (company && company !== 'null') {
    config = {
      ...config,
      headersRequest: {
        ...config.headersRequest,
        empresa: company
      }
    };
  }
  return config;
};

export const listOptions = (payload) => {
  const config = {
    operacionId: 'cl.list.options',
    ...(payload.company && {
      headersRequest: {
        empresa: payload.company
      }
    })
  };
  const params = apiClient.queryParams(payload);
  return apiClient.get(`${RESOURCE}?${params}`, config);
};

export const listV2Options = (payload) => {
  const config = {
    operacionId: 'cl.list.optionsv2',
    ...(payload.company && {
      headersRequest: {
        empresa: payload.company
      }
    })
  };
  const params = apiClient.queryParams(payload);
  return apiClient.get(`v2${RESOURCE}?${params}`, config);
};

export const listOptionsWithCustomParams = (payload) => {
  const params = apiClient.customQueryParams(payload);
  return apiClient.get(`${RESOURCE}?${params}`, { operacionId: 'cl.list.options' });
};

export const listV2OptionsWithCompany = ({ payload, company }) => {
  const config = getCompanyConfig('cl.list.optionsv2', { company });

  const params = apiClient.queryParams(payload);
  return apiClient.get(`v2${RESOURCE}?${params}`, config);
};

export const listV2OptionsUsers = (payload) => {
  const params = apiClient.queryParams(payload);
  return apiClient.get(`v2${RESOURCE}/${payload.id}/relaciones/usuarios?${params}`, { operacionId: 'cl.list.options.users' });
};

export const updateOptionsUsers = (body) => {
  const params = apiClient.queryParams(body);
  return apiClient.post(`v2${RESOURCE}/${body.id}/relaciones/usuarios?${params}`, body, { operacionId: 'cl.update.options.users' });
};

export const deleteOptionUser = (payload) => {
  const params = apiClient.queryParams(payload);
  return apiClient.delete(`v2${RESOURCE}/${payload.id}/relaciones/usuarios/${payload.usuario_id}?${params}`, { operacionId: 'cl.delete.options.user' });
};

export const getOption = (febosId) => {
  const params = apiClient.queryParams({ febosId });
  return apiClient.get(`${RESOURCE}?${params}`, { operacionId: 'cl.get.option' });
};

export const saveOption = (payload) => apiClient
  .post(RESOURCE, { opcion: payload }, { operacionId: 'cl.save.option' });

export const saveParentOption = (payload) => {
  const params = apiClient.queryParams({ origen: 'opcionPadre' });
  return apiClient.post(`${RESOURCE}?${params}`, { opcion: payload },
    { operacionId: 'cl.save.option' });
};
